import axios from '../api/axios';

export async function getModels() {
  const res = await axios.get(`/vehicleModels`);

  return res.data;
}

export async function getModelsByMake(vehicleMakeId) {
  const res = await axios.get(`/vehicleMakes/${vehicleMakeId}/vehicleModels`);

  return res.data;
}

export async function createModel(body) {
  console.log(body);
  const response = await axios.post('/vehicleModels', JSON.stringify(body), {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
}

export async function updateModel(modelId, body) {
  const response = await axios.patch(
    `/vehicleModels/${modelId}`,
    JSON.stringify(body),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
}

export async function deleteModel(modelId) {
  const response = await axios.delete(`/vehicleModels/${modelId}`);
  return response;
}
